<app-not-authorized-notice has="deviceManagement"></app-not-authorized-notice>

<app-data-set
	#dataSet
	[dataSource]="dataSource"
	defaultPresentationMode="table"
	firstColumnProperty="device.serialNumber"
	[rowId]="rowId"
	[enablePersistentSelection]="true"
	[appHasSystemCapability]
	has="deviceManagement"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="serialNumber"
				[defaultFilterLabel]="filterLabels.serialNumber"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.serialNumber }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('serialNumber')"
								data-automation-id="serial-number-input"
								(ngModelChange)="dataSet.filter('serialNumber', filterLabels.serialNumber, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.deviceGroups }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('group')"
								data-automation-id="device-group-input"
								(ngModelChange)="dataSet.filter('group', filterLabels.deviceGroups, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.status }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('displayStatus')"
								data-automation-id="status-input"
								(ngModelChange)="dataSet.filter('displayStatus', filterLabels.status, $event)"
							/>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.propertyName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('propertyName')"
								data-automation-id="property-name-input"
								(ngModelChange)="dataSet.filter('propertyName', filterLabels.propertyName, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.streetAddress }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('streetAddress')"
								data-automation-id="address-input"
								(ngModelChange)="dataSet.filter('streetAddress', filterLabels.streetAddress, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.townCity }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('locality')"
								data-automation-id="city-input"
								(ngModelChange)="dataSet.filter('locality', filterLabels.townCity, $event)"
							/>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.stateProvince }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('stateProvinceRegion')"
								data-automation-id="province-input"
								(ngModelChange)="dataSet.filter('stateProvinceRegion', filterLabels.stateProvince, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.postalCode }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('postalCode')"
								data-automation-id="postal-code-input"
								(ngModelChange)="dataSet.filter('postalCode', filterLabels.postalCode, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.country }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('countryCode')"
								data-automation-id="country-input"
								(ngModelChange)="dataSet.filter('countryCode', filterLabels.country, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(devicesLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(devicesLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="rowCheckbox">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						<app-data-set-table-row-selection [data]="row"> </app-data-set-table-row-selection>
					</td>
				</ng-container>

				<ng-container matColumnDef="serialNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@serialNumber">Serial Number</th>
					<td mat-cell *matCellDef="let element">{{ element.device.serialNumber }}</td>
				</ng-container>

				<ng-container matColumnDef="propertyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyName">Property Name</th>
					<td mat-cell *matCellDef="let element">
						{{ element.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="deviceLocation">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@addDeviceDeviceLocation">Device Location</th>
					<td mat-cell *matCellDef="let element">
						{{ element.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="group">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@group(s)">Group(s)</th>
					<td mat-cell *matCellDef="let element">
						<app-overflow-chip-list [chips]="element.groupNames"></app-overflow-chip-list>
					</td>
				</ng-container>

				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@status">Status</th>
					<td mat-cell *matCellDef="let element" i18n-mat-cell="@@inServiceNotInService">
						@if (element.device.activeDeviceAssignment) {
							<span i18n="@@addDeviceGroupDevices-inService">In Service</span>
						}
						@if (!element.device.activeDeviceAssignment) {
							<span i18n="@@addDeviceGroupDevices-notInService">Not In Service</span>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
